import tzLookup from 'tz-lookup';

export const TIMEZONE_FALLBACK = 'N/A';

export const timeZoneDisplayByIana: Record<string, string> = {
  'America/New_York': 'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Detroit': 'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Indiana/Indianapolis':
    'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Indiana/Vincennes':
    'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Indiana/Winamac':
    'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Indiana/Marengo':
    'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Indiana/Petersburg':
    'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Indiana/Vevay':
    'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Kentucky/Louisville':
    'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Kentucky/Monticello':
    'Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4',
  'America/Chicago': 'Central Standard Time (CST/CDT) - UTC-6 / UTC-5',
  'America/Indiana/Tell_City':
    'Central Standard Time (CST/CDT) - UTC-6 / UTC-5',
  'America/Indiana/Knox':
    'Central Standard Time (CST/CDT) - UTC-6 / UTC-5',
  'America/Menominee': 'Central Standard Time (CST/CDT) - UTC-6 / UTC-5',
  'America/North_Dakota/Beulah':
    'Central Standard Time (CST/CDT) - UTC-6 / UTC-5',
  'America/North_Dakota/Center':
    'Central Standard Time (CST/CDT) - UTC-6 / UTC-5',
  'America/North_Dakota/New_Salem':
    'Central Standard Time (CST/CDT) - UTC-6 / UTC-5',
  'America/Denver': 'Mountain Standard Time (MST/MDT) - UTC-7 / UTC-6',
  'America/Boise': 'Mountain Standard Time (MST/MDT) - UTC-7 / UTC-6',
  'America/Phoenix': 'Mountain Standard Time (MST/MDT) - UTC-7 / UTC-6',
  'America/Los_Angeles': 'Pacific Standard Time (PST/PDT) - UTC-8 / UTC-7',
  'America/Anchorage': 'Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8',
  'America/Juneau': 'Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8',
  'America/Sitka': 'Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8',
  'America/Metlakatla': 'Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8',
  'America/Nome': 'Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8',
  'America/Yakutat': 'Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8',
  'Pacific/Honolulu': 'Hawaii-Aleutian Standard Time (HST) - UTC-10',
  'America/Halifax': 'Atlantic Standard Time (AST) - UTC-4',
  'America/Puerto_Rico': 'Atlantic Standard Time (AST) - UTC-4',
  'Pacific/Guam': 'Chamorro Standard Time (ChST) - UTC+10',
  'Pacific/Saipan': 'Chamorro Standard Time (ChST) - UTC+10',
  'Asia/Karachi': 'Pakistan Standard Time (PST) - UTC+5'
};

type CityTimezoneMatch = {
  timezone?: string;
};

export const getTimeZoneDisplayFromIana = (
  ianaTimeZone?: string | null
): string => {
  if (!ianaTimeZone) {
    return TIMEZONE_FALLBACK;
  }

  return timeZoneDisplayByIana[ianaTimeZone] || TIMEZONE_FALLBACK;
};

export const resolveTimezoneFromCoordinates = (
  latitude: number,
  longitude: number
): { ianaTimeZone: string; displayTimeZone: string } => {
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return { ianaTimeZone: '', displayTimeZone: TIMEZONE_FALLBACK };
  }

  try {
    const ianaTimeZone = tzLookup(latitude, longitude);

    return {
      ianaTimeZone,
      displayTimeZone: getTimeZoneDisplayFromIana(ianaTimeZone)
    };
  } catch {
    return { ianaTimeZone: '', displayTimeZone: TIMEZONE_FALLBACK };
  }
};

export const resolveTimezoneFromCityMatches = (
  matches: CityTimezoneMatch[] = []
): string => {
  const mappedMatch = matches.find((match) =>
    Boolean(getTimeZoneDisplayFromIana(match?.timezone) !== TIMEZONE_FALLBACK)
  );

  return getTimeZoneDisplayFromIana(mappedMatch?.timezone);
};
